import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  UpdateIndustryMutation as UpdateIndustryMutationType,
  UpdateIndustryMutationVariables,
} from "./__generated__/UpdateIndustryMutation";

const UpdateIndustryMutation = loader("./UpdateIndustryMutation.gql");

type UpdateIndustryMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: UpdateIndustryMutationType) => void;
}) => ReactElement;

export const UpdateIndustryMutationProvider: UpdateIndustryMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<UpdateIndustryMutationType, UpdateIndustryMutationVariables>(
    UpdateIndustryMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
